import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const OpenIQPersona4Icon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 48 48">
    <circle cx="24" cy="24" r="24" fill="#EEECEB" />
    <path
      d="M25 2C27.1083 2 29.025 2.81662 30.4541 4.14941C30.9543 4.05148 31.4711 4 32 4C36.4183 4 40 7.58172 40 12C40 12.5286 39.9474 13.045 39.8496 13.5449C41.183 14.9741 42 16.8912 42 19C42 22.4093 39.8663 25.3179 36.8623 26.4697C36.172 30.1858 32.916 33 29 33C24.5817 33 21 29.4183 21 25C21 23.6749 21.3233 22.4257 21.8936 21.3252C20.5405 22.3735 18.8441 23 17 23C12.5817 23 9 19.4183 9 15C9 10.5817 12.5817 7 17 7C17.1931 7 17.3845 7.009 17.5742 7.02246C18.7555 4.07906 21.6343 2 25 2ZM24.4248 17.9766C24.3292 18.2149 24.2227 18.4475 24.1055 18.6738C24.4293 18.4229 24.7722 18.1956 25.1328 17.9961C25.0886 17.9968 25.0444 18 25 18C24.8065 18 24.6149 17.9901 24.4248 17.9766Z"
      fill="#00B866"
    />
    <path
      d="M36.5537 33C39.7269 33 42.8074 33.4022 45.751 34.1543C41.9261 42.333 33.6262 48 24.001 48C18.9416 48 14.249 46.4328 10.3789 43.7598C17.1536 37.0995 26.3819 33 36.5537 33Z"
      fill="#0C0B5A"
    />
    <path
      d="M26.6191 15.7666V20.1689H27.6582C27.8906 18.7434 29.1279 17.6553 30.6191 17.6553C31.5916 17.6553 32.4538 18.1197 33.002 18.8369C33.3878 19.3417 33.6191 19.9709 33.6191 20.6553C33.6191 21.3407 33.3868 21.9704 33 22.4756V22.4795C32.6122 22.9837 32.0671 23.3608 31.4385 23.5391L33 26.2422V37.6553C33 39.3121 30.3137 40.6553 27 40.6553C23.6863 40.6553 21 39.3121 21 37.6553V32C17.6863 32 15 29.1594 15 25.6553V17.6553C15 15.9517 15.4726 14.3582 16.2949 13L26.6191 15.7666Z"
      fill="#F0B824"
    />
    <path d="M21 32H29L21 38V32Z" fill="#CA9B1E" />
  </SvgIcon>
);
